import { cn } from '@/shared/lib/utils'
import {
  CLIENT_ACCOUNT_STATUS,
  CLIENT_ACCOUNT_STATUS_LABELS,
  type ClientAccountStatus
} from '../models/client-account-admin-v2'

/**
 * El estado de una cuenta de la app, con el badge sobrio del back-office: píldora gris y
 * el color en un PUNTO, no en el fondo. Es la convención que ya usan proyectos, usuarios
 * y el resto de los listados — una fila con cinco píldoras de colores plenos se vuelve
 * ilegible, y el color de fondo compite con la selección de la fila.
 *
 * Los tres estados no son decorativos: cada uno implica una acción distinta. «Sin
 * ingresar» es lo accionable (se le reenvía la invitación), «Bloqueada» es una decisión
 * que alguien tomó y hay que revertir a mano, y «Activa» no pide nada.
 */
const DOT_BY_STATUS: Record<ClientAccountStatus, string> = {
  [CLIENT_ACCOUNT_STATUS.ACTIVE]: 'bg-emerald-500',
  // Ámbar y no rojo: no está roto, está PENDIENTE. El rojo se reserva para el bloqueo,
  // que sí es una interrupción.
  [CLIENT_ACCOUNT_STATUS.NEVER_SIGNED_IN]: 'bg-amber-500',
  [CLIENT_ACCOUNT_STATUS.BLOCKED]: 'bg-destructive'
}

type ClientAccountStatusBadgeProps = {
  status: ClientAccountStatus
  className?: string
}

export function ClientAccountStatusBadge({ status, className }: ClientAccountStatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-foreground/80',
        className
      )}
    >
      <span
        aria-hidden="true"
        className={cn('h-1.5 w-1.5 shrink-0 rounded-full', DOT_BY_STATUS[status])}
      />
      {CLIENT_ACCOUNT_STATUS_LABELS[status]}
    </span>
  )
}
